module.exports = __webpack_public_path__ + "img/twoblock.15986bb0.png";